require('./bundle-manifest').register(JSON.parse("{\"2h6VV\":\"index.e128acd9.js\",\"Tlom4\":\"philosopher.13411219.svg\",\"2BGDH\":\"index.6bd3cd43.css\"}"));